import { Manager } from 'socket.io-client';

export const createFeedGatewayClient = (url: string, apiKey: string) =>
    new Manager(url, {
        withCredentials: true
    })
        .socket('/feed/gateway')
        .onAnyOutgoing((event: string) => console.debug(`Automatization gateway outgoing`, event));

export const createPumpGatewayClient = (url: string, apiKey: string) =>
    new Manager(url, {
        withCredentials: true
    })
        .socket('/pump/gateway')
        .onAnyOutgoing((event: string) => console.debug(`Automatization gateway outgoing`, event));

export const createBonkGatewayClient = (url: string, apiKey: string) =>
    new Manager(url, {
        withCredentials: true
    })
        .socket('/bonk/gateway')
        .onAnyOutgoing((event: string) => console.debug(`Automatization gateway outgoing`, event));
